import {
  Workflow, WorkflowStep, WorkflowCondition, ConditionOperator,
} from '../../../services/WorkflowService';

// -- Workflow Transforms --------------------------------------------

export const updateBasicInfo = (
  workflow: Workflow,
  info: Partial<Pick<Workflow, 'name' | 'description' | 'trigger' | 'isActive'>>,
): Workflow => ({ ...workflow, ...info });

export const setConditionOperator = (workflow: Workflow, operator: ConditionOperator): Workflow => ({
  ...workflow,
  conditionOperator: operator,
});

// -- Step Transforms ------------------------------------------------

export const addStep = (workflow: Workflow, step: WorkflowStep): Workflow => ({
  ...workflow,
  steps: [...workflow.steps, step],
});

export const removeStep = (workflow: Workflow, index: number): Workflow => ({
  ...workflow,
  steps: workflow.steps
    .filter((_, i) => i !== index)
    .map((s, i) => ({ ...s, order: i + 1 })),
});

export const reorderSteps = (workflow: Workflow, reordered: WorkflowStep[]): Workflow => ({
  ...workflow,
  steps: reordered.map((s, i) => ({ ...s, order: i + 1 })),
});

export const mergeStep = (
  workflow: Workflow,
  index: number,
  updates: Partial<WorkflowStep>,
): Workflow => ({
  ...workflow,
  steps: workflow.steps.map((s, i) =>
    i === index ? { ...s, ...updates } : s
  ),
});

export const setSteps = (workflow: Workflow, steps: WorkflowStep[]): Workflow => ({
  ...workflow,
  steps,
});

// -- Condition Transforms -------------------------------------------

export const addCondition = (workflow: Workflow, condition: WorkflowCondition): Workflow => ({
  ...workflow,
  conditions: [...workflow.conditions, condition],
});

export const removeCondition = (workflow: Workflow, index: number): Workflow => ({
  ...workflow,
  conditions: workflow.conditions.filter((_, i) => i !== index),
});

export const updateConditionField = (
  workflow: Workflow,
  index: number,
  field: keyof WorkflowCondition,
  value: string,
): Workflow => ({
  ...workflow,
  conditions: workflow.conditions.map((c, i) =>
    i === index ? { ...c, [field]: value } : c
  ),
});

export const setConditions = (workflow: Workflow, conditions: WorkflowCondition[]): Workflow => ({
  ...workflow,
  conditions,
});